export default {
    setTablesTypesList(state, value){
        state.tablesTypesList = value;
    },
    setFilteredRawTablesTypesList(state, value){
        state.selectedTablesTypesList = value;
    },
    setFilteredRawTablesTypesObjectList(state, value) {
        state.filteredRawTablesTypesObjects = value;
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/rawDataPartnersReport/mutations.js